import React from "react";
import { Link } from "react-router-dom";

const Navbar = ({toggle}) => {
  return (

    <div className="container px-10 mx-auto">
    <nav className="flex justify-between items-center h-16  text-black relative
    "
    role="navigation"
    >
      <Link to="/" className="">
         <span className="text-xl">Rian Islam</span> 
      </Link>

      <div onClick={toggle} className="px-4 cursor-pointer md:hidden">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
            clipRule="evenodd"
          />
        </svg>
      </div>

      <div className="pr-8 md:block hidden">
      <Link  className=" p-4"  to="/education">Education</Link>
      <Link className=" p-4"  to="/about">About</Link>
          
          <Link className="p-4"  to="/projects">Projects</Link>
          {/* <Link className="p-4"  to="/works">Works</Link> */}
          
          <Link  className="p-4" to="/contacts">Contact</Link>
      </div>
    </nav>
    </div>
  );
};

export default Navbar;
